module.exports = __webpack_public_path__ + "static/media/PROMO.8edf76ff.png";